export default __webpack_public_path__ + "static/media/pantry2-after1-1440w.301fb9bd.avif";